var styles = {"navbarLink":"navkit__NavbarLink__navbarLink","isActive":"navkit__NavbarLink__isActive","hasIcon":"navkit__NavbarLink__hasIcon","isDisableUnderline":"navkit__NavbarLink__isDisableUnderline","isDisabled":"navkit__NavbarLink__isDisabled"};

export { styles as default };
